module.exports = __webpack_public_path__ + "static/media/dontPixel.5e69c5aa.png";